import { Box, Checkbox, Grid, Typography } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { Shortcut } from 'modules/shortcuts/models';
import React from 'react';

interface IShortcutLeadingCell {
    shortcut: Shortcut;
    selected: boolean;
    onEditShortcut: (shortcut: Shortcut) => void;
    onSelectShortcut: (selected: boolean, shortcut: Shortcut) => void;
}

export const ShortcutLeadingCell: React.FC<IShortcutLeadingCell> = ({
    shortcut,
    selected,
    onEditShortcut,
    onSelectShortcut
}) => {
    return <Grid 
        container
        wrap="nowrap"
        alignItems="center"
    >
        <Grid item padding="checkbox">
            <Checkbox
                color="primary"
                checked={selected}
                onChange={(_, checked) => onSelectShortcut(checked, shortcut)} />
        </Grid>
        <Grid item sx={{ overflowX: "clip" }}>
            <Box 
                sx={{
                    display: "inline-flex",
                    flexDirection: "row",
                    flexWrap: "nowrap",
                    alignItems: "center",
                    width: "max-content"
                }}
            >
                <Typography onClick={() => onEditShortcut(shortcut)}>
                    {shortcut.name}
                </Typography>
                {
                    shortcut.audiences.length !== 0 &&
                    <span className="shortcut-lock-icon"><LockIcon/></span>
                }
            </Box>
        </Grid>
    </Grid>;
};